import { Link } from "react-router-dom";
import { genreCategories } from "@/mocks/categories";
import { movies } from "@/mocks/movies";

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      {genreCategories.map((category) => {
        const count = movies.filter((movie) => movie.genres.includes(category.name)).length;
        return (
          <Link
            key={category.name}
            to={`/category?genre=${encodeURIComponent(category.name)}`}
            className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${category.icon} text-lg leading-none`} />
            </span>
            <span>
              <span className="flex items-baseline gap-1.5">
                <span className="font-heading text-sm text-foreground-950">{category.name}</span>
                <span className="text-[10px] text-foreground-400">{count} 部</span>
              </span>
              <span className="mt-1 block text-[11px] leading-relaxed text-foreground-500">
                {category.description}
              </span>
            </span>
          </Link>
        );
      })}
    </div>
  );
}